var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharpOutlineUsers1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8619 3.14502C15.2898 3.00001 14.7273 3 13.8182 3.00001L15.1818 4.8L15.4109 4.88877C15.9975 5.03747 16.5175 5.37524 16.8888 5.84883C17.2601 6.32242 17.4617 6.90488 17.4617 7.50439C17.4617 8.10391 17.2601 8.68637 16.8888 9.15996C16.5175 9.63355 15.9975 9.97132 15.4109 10.12L15.1818 10.2L13.8182 12C14.7273 12 15.1818 12 15.8619 11.8638C16.8396 11.6159 17.7062 11.053 18.3251 10.2637C18.9439 9.47436 19.2799 8.50359 19.2799 7.50439C19.2799 6.5052 18.9439 5.53443 18.3251 4.74512C17.7062 3.95581 16.8396 3.39286 15.8619 3.14502Z",
    fill: "#B9BDC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1818 3C7.67143 3 5.63636 5.01472 5.63636 7.5C5.63636 9.98528 7.67143 12 10.1818 12C12.6922 12 14.7273 9.98528 14.7273 7.5C14.7273 5.01472 12.6922 3 10.1818 3ZM7.45455 7.5C7.45455 6.00883 8.67559 4.8 10.1818 4.8C11.688 4.8 12.9091 6.00883 12.9091 7.5C12.9091 8.99117 11.688 10.2 10.1818 10.2C8.67559 10.2 7.45455 8.99117 7.45455 7.5Z",
    fill: "#B9BDC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31818 13.8C5.1533 13.8 4.04899 14.2892 3.24437 15.1389C2.44162 15.9866 2 17.1246 2 18.3V21H3.81818V18.3C3.81818 17.5658 4.0949 16.8725 4.57081 16.37C5.04485 15.8694 5.67477 15.6 6.31818 15.6H13.1364C13.7798 15.6 14.4097 15.8694 14.8837 16.37C15.3596 16.8725 15.6364 17.5658 15.6364 18.3V21H17.4545V18.3C17.4545 17.1246 17.0129 15.9866 16.2102 15.1389C15.4056 14.2892 14.3012 13.8 13.1364 13.8H6.31818Z",
    fill: "#B9BDC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5455 13.8C17.3868 13.7565 17.8244 13.7776 18.5909 13.9455C19.5661 14.1947 20.43 14.7576 21.047 15.5456C21.664 16.3336 21.9992 17.3022 22 18.2992V20.9999H20.1818V18.3006C20.1813 17.7024 19.9802 17.1211 19.61 16.6484C19.2398 16.1756 18.7215 15.8379 18.1364 15.6883L17.9091 15.6L16.5455 13.8Z",
    fill: "#B9BDC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharpOutlineUsers1);
export default __webpack_public_path__ + "static/media/sharp--outline--users1.0c1e2e6a6a531f529cba1353d9a52f18.svg";
export { ForwardRef as ReactComponent };